import React from 'react'
import { useStore } from 'src/state'
import Page from 'src/components/page'
import Section from 'src/components/section'
import Container from 'src/components/container'
import KlaviyoForm from 'src/components/klaviyo-form'

const MembershipApplyPage = () => {
  const {
    membershipApplyPage: {
      hero: { title },
      form: { formId },
    },
  } = useStore()

  return (
    <Page className="page-membership-apply">
      <Section className="head">
        <Container>
          <h1 className="title centered">{title}</h1>
        </Container>
      </Section>
      <Section className="form">
        <Container maxWidth={false}>
          <KlaviyoForm formId={formId} />
        </Container>
      </Section>
    </Page>
  )
}

export default MembershipApplyPage
